import React from 'react'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import { SquareIconButton } from '@/modules/base/components/buttons'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconDownload from '@assets/images/icons/download.svg'
import IconPDF from '@assets/images/icons/pdf-extension.svg'
import { downloadFile } from '@/modules/_helpers/downloadFile'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { File } from '@/modules/signature/types'
import customDecodeUri from '@/utils/customDecodeUri'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: theme.fontSizes.smedium,
    fontWeight: theme.fontWeights.medium,
  },
  document: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  documentDetails: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.fontSizes.small,
  },
  documentName: {
    marginLeft: 10,
    maxWidth: 300,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}), { name: 'SignatureSigningDocument' })

interface SignatureSigningDocumentProps {
  document: File
}

const SignatureSigningDocument = (props: SignatureSigningDocumentProps) => {
  const classes = useStyles()
  const { document } = props

  if (!document) { return null }
  const documentName = customDecodeUri(document?.name)

  const handleDownload = async(): Promise<void> => {
    try {
      const { url, mimeType } = document
      await downloadFile(url, documentName, mimeType)
    } catch (error) {
      toast.showToast({ type: 'error', message: lang.signature.signing.errors.downloadDocument })
    }
  }

  return (
    <div className={classes.root}>
      <span className={classes.title}>{lang.signature.signing.documents.title}</span>
      <div className={classes.document}>
        <div className={classes.documentDetails}>
          <SVGIcon svg={IconPDF} height="24px" width="24px" />
          <span className={classes.documentName}>{documentName}</span>
        </div>
        <SquareIconButton icon={IconDownload} onClick={handleDownload} />
      </div>
    </div>
  )
}

export default SignatureSigningDocument
